import { Component } from "@/types/types"
import { TextLink } from "@/ui/atoms/controls/TextLink"
import { SectionContainer } from "@/ui/layouts/SectionContainer"
import { cx } from "@/utils/cx"
import { tx } from "@/utils/tx"
import { CookieButton } from "./_elements/CookieButton"

export const COMPONENT_NAME = "globalFooter"

export const presets = {}

export interface Props extends Component {}

export function GlobalFooter({ className, testId = COMPONENT_NAME }: Props) {
  return (
    <footer className={cx(`bg-background`, className)} data-test={testId}>
      <SectionContainer>
        <div
          className={cx(
            `text-sm flex flex-col pt-12 pb-8`,
            `md:flex-row md:items-center md:py-10 gap-4 md:gap-8`,
          )}
        >
          <div className="grow">
            <div className="" data-test={tx(COMPONENT_NAME, "disclaimerText")}>
              © 2000 - {new Date().getFullYear()} SANS™ Institute
            </div>
          </div>

          <div
            className={cx(
              `flex flex-col gap-3 items-start`,
              `sm:flex-row sm:items-center sm:gap-6`,
              "md:pr-16 min-[1548px]:pr-0", // reserve space for the support button
            )}
          >
            <CookieButton />

            <TextLink
              href="https://help.sans-foundations.com/help"
              className="text-left !font-normal"
              testId={tx(COMPONENT_NAME, "knowledgeBaseLink")}
              style="bold"
            >
              Knowledge base
            </TextLink>

            <TextLink
              href="/terms"
              className="text-left !font-normal"
              testId={tx(COMPONENT_NAME, "termsLink")}
              style="bold"
              newTab
            >
              Terms & Conditions
            </TextLink>
          </div>
        </div>
      </SectionContainer>
    </footer>
  )
}
